import { ERROR_SERVER, GET_ACCESS_BUILDINGS, IS_FETCHING, SET_ACCESS_BUILDING_SEARCHABLE } from "./types";

const AccessBuildingReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ACCESS_BUILDINGS:
            return {
                ...state,
                accessBuildings: payload,
                accessBuildingsSearchable: payload,
                isFetching: false,
                error: false,
                wasFetched: true,
                message: ''
            }
        case SET_ACCESS_BUILDING_SEARCHABLE:
            return {
                ...state,
                accessBuildingsSearchable: payload,
            }
        case IS_FETCHING:
            return {
                ...state,
                accessBuildings: [],
                accessBuildingsSearchable: [],
                isFetching: true,
                error: false,
                message: '',
                wasFetched: false
            }
        case ERROR_SERVER:
            return {
                ...state,
                isFetching: false,
                error: true,
                wasFetched: false,
                message: payload
            }

        default:
            return state
    }
}

export default AccessBuildingReducer